export const getEpochUrl = (
  id: string,
  notch: string,
  band: string,
  epochSize: number | string,
  epochSelected: number | string
) => `/graphs/${id}/${notch}/${band}/${epochSize}/${epochSelected}/`;

export const getReportsUrl = (id: string) => `/report/${id}/`;
